// USA
export const locale = {
    lang: 'en',
    data: {
        TRANSLATOR: {
            SELECT: 'Select your language',
            ENTITY: 'Entity',
        },
        DATEPICKER: {
            IntervalOfDates: 'Interval of Dates',
            Initial: 'Inicial',
            End: 'End',
            Year: 'Year',
            Month: 'Month',
            Day: 'Day',
            Select: 'Select',
        },
        ACTION: {
            Cancel: 'Cancel',
            Back: 'Back',
            Confirm: 'Confirm',
            Clear: 'Clear',
            Export: 'Export',
            Filter: 'Filter',
            Search: 'Search',
        },
        MENU: {
            NEW: 'new',
            ACTIONS: 'Actions',
            CASHIER: 'Cashier',
            CREATE_POST: 'Create New Post',
            PAGES: 'Pages',
            FEATURES: 'Features',
            APPS: 'Apps',
            DASHBOARD: 'Dashboard',
            ACCOUNTRECEIVING: 'Accounts Receiving',
            FILERETURN: 'File Return',
            COLLECTORFILE: 'Collector Files',
            MANAGE: 'Manage',
            IMPORT: 'Import',
            BACKPREVIOUSMENU: 'Back to previous menu',
            FILEREMITANCE: 'Shipping Files',
            FILEGENERATE: 'Generate File',
            TOOLS: 'Tools',
            ROUNDING: 'Rounding',
            MANAGEMENT: 'Management',
            CHANGECONTRACT: 'Contract Change',
            RECORDSCARD: 'Card Registration',
            RECURRINGCARD: 'Recurring Card',
            CREDITCARDRECURRENCE: 'Credit Card Recurrences',
            RECURRENCEMANAGEMENT: 'Recurrence Management',
            TASKS: 'Tasks',
            FINANCIAL: 'Financial',
            MANAGEBUGS: 'Manage Errors',
            DEVELOPMENT: 'Development',
            DUE_DATE_IN_BATCHES: 'Due Date in Batches',
            BILLET: 'Billet',
            REPORT: 'Report',
            FATURATION: 'Faturation',
            BACK: 'Back',
            MappingCurrentAccountBillet: 'Billets Mapping ',
            ACCOUNTING: 'Accounting',
            ACCOUNTING_BATCH: 'Accouting Batch',
            RECEIVING: 'Receiving',
            RECEIVINGS: 'Receivings',
            PIX: 'PIX',
        },
        STATUS: {
            All: 'All',
            Add: 'Add',
            Alter: 'Alter',
            Cancel: 'Cancel',
            WritOff: 'WritOff',
        },
        CardRecurrence: 'Recurring Card',
        NoRecurrence: 'No Recurrence',
        Scheduled: 'Scheduled',
        Confirmed: 'Confirmed',
        Error: 'Error',
        Processing: 'Processing',
        RetirementPending: 'Retirement Pending',
        NoneFinancialAgreement: 'None FinancialAgreement',
        Unauthorized: 'Unauthorized',
        NoCapture: 'NoCapture',
        All: 'All',
        SELECT: {},
        ENUM: {
            NoRecurrence: 'No Recurrence',
            Scheduled: 'Scheduled',
            Confirmed: 'Confirmed',
            Error: 'Error',
            Processing: 'Processing',
            RetirementPending: 'Retirement Pending',
            NoneFinancialAgreement: 'None FinancialAgreement',
            Unauthorized: 'Unauthorized',
            NoCapture: 'NoCapture',
            All: 'All',
            Opened: 'Opened',
            Closed: 'Closed',
            Accounted: 'Accounted',
        },
        MESSAGES: {
            HOMEMESSAGE:
                'We are preparing new content for you. In the meantime you can browse other screens through the menu on the left side',
            WELCOME: 'Welcome',
        },
        CASHIERMANAGEMENT: {
            dateOpen: 'Date Open',
            dateClose: 'Date Close',
            user: 'User',
            numberCasher: 'Number Casher',
            entity: 'Entity',
            statusCashier: 'Status Cashier',
            clear: 'Clear',
            filter: 'Filter',
            export: 'Export',
            thereIsNoDataToLoad: 'There is no Data to Load',
            deposit: 'Deposit',
            deposit2: 'Deposit',
            accountsBank: 'Accounts Bank',
            accountBank: 'Account Bank',
            depositDate: 'Deposit Date',
            value: 'Value',
            add: 'Add',
            date: 'Date',
            thereIsNoDepositAdded: 'There is no Deposit Added',
            amountToDeposit: 'Amount to Deposit',
            depositedAmount: 'Deposited Amount',
            missingValue: 'Missing Value',
            cancel: 'Clear',
            start: 'Start',
            final: 'Final',
            opening_interval: 'Opening Interval',
            apply: 'Apply',
            payment: 'Payment',
            receipt: 'Receipt',
            toDeposit: 'To Deposit',
            accounted: 'Accounted',
            transfer_of_cashier: 'Transfer of Cashier',
            transfer: 'Transfer',
            transfer_cashier: 'Transfer Cashier',
            search: 'Search',
            print: 'Print',
            cashier: 'Cashier',
            are_you_sure_you_want_to_transfer_cashier_to_this_selected_cashier:
                'Are you sure you want to transfer cashier to this selected cashier?',
            please_select_cashier: 'Please select cashier',
            cashier_transferred: 'Cashier Transferred',
        },
        BILLET: {
            start: 'Start',
            final: 'Final',
            cancel: 'Cancel',
            apply: 'Apply',
            due_date_range: 'Due Date Range',
            period: 'Period',
            service: 'Service',
            clear: 'Clear',
            search: 'Search',
            thereIsNoDataToLoad: 'There is no Data to Load',
            contract: 'Contract',
            student: 'Student',
            number: 'Number',
            dueDate: 'DueDate',
            value: 'Value',
            alter: 'Alter',
            filters: 'Filters',
            changes: 'Changes',
            new_due_date: 'New Due Date',
            alter_all: 'Alter All',
            alter_selecteds: 'Alter Selecteds',
            due_date_in_batches: 'Due Date in Batches',
            confirmation_of_alteration: 'Confirmation of Alteration',
            are_you_sure_you_want_to_change_expiration_date: 'Are you sure you want to change expiration date',
            of_all_filtered_bills: 'of all filtered bills',
            of_the_selected_bills: 'of the selected bills',
            expiration_date_successfully_changed: 'Expiration date successfully changed',
            registered: 'Registered',
            discounts_will_accompany_change: 'Discounts will accompany change',
            discount: 'Discount',
            wait_for_processing: 'Wait for Processing',
        },
        GENERAL: {
            yes: 'Yes',
            no: 'No',
        },
        FILEGENERATE: {
            dueDate: 'Due Date',
            billetNumber: 'N° Invoice',
            billetCode: 'billet Code',
            ourNumber: 'Nosso Numero',
            beneficiary: 'Beneficiary',
            responsible: 'Responsible',
            value: 'Value',
            dateRequested: 'Data Requested',
            status: 'Exchange Rate',
        },
        STATUSRETURNLINE: {
            standby: 'StandBy',
            sheduled: 'Scheduled',
            enqueued: 'Enqueued',
            awaiting: 'Awaiting',
            proccessing: 'Processing',
            success: 'Succeeded',
            failed: 'Failed',
            deleted: 'Deleted',
            accounted: 'Accounted',
            pendency: 'Pendency',
            all: 'All',
        },
        AUDITRETURNFILE: {
            delete_with_successful: 'Item deleted successfully!',
            items_with_valores_duplicates: 'There are items with duplicate values. Please remove wrong item!',
            error_to_delete: 'Error to delete!',
        },
        JournalType: {
            All: 'All',
            AccountsPayable: 'Accounts Payable',
            Provision: 'Provision',
            AnticipatedRevenue: 'Anticipated Revenue',
            Receiving: 'Receiving',
            Payment: 'Payment',
            Remittance: 'Remittance', // obs
            CheckTransit: 'Check Transit',
            Imported: 'Imported', // obs
            Uncollectible: 'Uncollectible',
            CardTransit: 'Card Transit', // obs
            Payment_Cashier: 'Payment/Cashier',
            Receiving_Cashier: 'Receiving/Cashier',
            Receiving_WebPayment: 'Receiving/Web Payment',
            Pix: 'Pix',
            Receiving_Pix: 'Receiving/Pix',
            Receiving_Migration: 'Receiving/Migration',
            Receiving_EarlyReceiving: 'Receiving/Early Receiving',
            Receiving_RecurringCard: 'Receiving/Recurring Card',
            Remittance_Cashier: 'Remittance/Cashier',
            Receiving_Bank: 'Receiving/Bank',
            Deposit_Cashier: 'Deposit/Cashier',
        },
        JournalStatus: {
            All: 'All',
            0: 'Export',
            None: 'None',
            Awaiting: 'Aguardando',
            Success: 'Exportado',
            CreationError: 'Erro na Criação',
            ExportError: 'Erro na exportação',
        },
        JournalErrors: {
            AccountNotFound: 'Account Not Found',
            SubAccountNotFound: 'Account Not Found',
            FunctionNotFound: 'Function Not Found',
            FundNotFound: 'Fund Not Found',
            RestrictionNotFound: 'Restriction Not Found',
            EntityNotFound: 'Entity Not Found',
            OpenAccountingMonthNotFound: 'Open Accounting Month Not Found',
        },
        Data: 'Date',
        'Tipo de Lote': 'Batch Type',
        Itens: 'Itens',
        Mês: 'Month',
        Ano: 'Year',
        Número: 'Number',
        'Nome de Usuário': 'User Name',
        Status: 'Status',
        'Cod. Escola': 'Cod. School',
        Aluno: 'Student',
        Responsável: 'Responsible',
        Parcela: 'Number of Payments',
        Bandeira: 'Payment Processors',
        'Nº Cartão': 'Number Card',
        Valor: 'Value',
        Vencimento: 'Expiration',
        ReturnCode: 'Return Code',
    },
};
